import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ColumnHeader from './UIs/ColumnHeader';
import { setSummaryColumn, setSummaryColumnOrder } from '../../../flow/actions';

const defaultProps = {};
const propTypes = {
  options: PropTypes.array.isRequired,
  sortOnCurrentColumn: PropTypes.bool.isRequired
};

class AggregateColumnHeader extends PureComponent {
  handleDropdownChange = val => this.props.setSummaryColumn(this.props.id, val);
  handleOrderClick = nextOrder =>
    this.props.setSummaryColumnOrder(this.props.id, nextOrder);

  render() {
    const {
      options,
      selectedValue,
      sortOrder,
      sortOnCurrentColumn
    } = this.props;
    return (
      <ColumnHeader
        onDropdownChange={this.handleDropdownChange}
        onOrderClick={this.handleOrderClick}
        options={options}
        selectedValue={selectedValue}
        sortOrder={sortOrder}
        sortOnCurrentColumn={sortOnCurrentColumn}
      />
    );
  }
}

// Utils
const reduceOptions = (data, fieldsMetaData) => {
  // !!! too many dependencies
  if (
    _.isEmpty(data) ||
    _.isEmpty(fieldsMetaData) ||
    !_.isArray(data.aggregatesZone)
  ) {
    return [];
  }

  const aggregates = data.aggregatesZone.filter(
    az => az.functions && az.functions.length > 0
  );
  // reduce
  const options = aggregates.reduce((result, aggregate) => {
    return [
      ...result,
      ...aggregate.functions.map(func => {
        const field = fieldsMetaData.find(
          meta => aggregate.field_name === meta.name && data.type === meta.objectType
        );
        return {
          key: field ? `${field.name}__${func}` : aggregate.field_name,
          action: func,
          name: field ? field.name : aggregate.field_name,
          label: !_.isEmpty(field) ? field.label : aggregate.field_name,
          restriction: !_.isEmpty(field) ? field.restriction : false,
          deleted: _.isEmpty(field)
        };
      })
    ];
  }, []);
  options.unshift({
    key: 'count',
    action: 'count',
    name: 'count',
    label: 'counnt',
    restriction: false,
  });
  return options;
};

// TODO: add implementations
const mapStateToProps = ({ metaData, global, dashboardSettings }, ownProps) => {
  const { id } = ownProps;
  const slotData = dashboardSettings.details.slots.find(s => s.id === id) || {};

  const { reportId } = slotData;
  const report = metaData.reports.data.find(r => r.id === reportId);

  const options = reduceOptions(report, metaData.fields.data);

  const sortOnCurrentColumn = slotData.orderSettings
    ? slotData.summarySettings === slotData.orderSettings.field_name
    : false;

  return {
    lang: global.language,
    options,
    selectedValue: slotData.summarySettings,
    // TODO: revise
    sortOrder: sortOnCurrentColumn
      ? slotData.orderSettings && slotData.orderSettings.direction
      : null,
    sortOnCurrentColumn
  };
};
const mapDispatchToProps = {
  setSummaryColumn,
  setSummaryColumnOrder
};
AggregateColumnHeader.defaultProps = defaultProps;
AggregateColumnHeader.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AggregateColumnHeader);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/Table/components/AggregateColumnHeader.jsx